import { slugify, normalize } from '~/assets/javascript/utils/string';

export * from './recent-navigation';
export * from './engine';
export * from './topbar';

export const slugifiedSearch = (searchTerm, searchItems) => {
  const result = [];
  const query = slugify(searchTerm);

  if (query !== '') {
    searchItems.forEach((item) => {
      if (slugify(JSON.stringify(item)).includes(query)) {
        result.push(item);
      }
    });
  }

  return result;
};

export const normalizedSearch = (searchTerm, searchItems) => {
  const result = [];
  const query = normalize(searchTerm.toLowerCase().replace(/\s/g, ''));

  if (query !== '') {
    searchItems.forEach((item) => {
      if (normalize(JSON.stringify(item)).includes(query)) {
        result.push(item);
      }
    });
  }

  return result;
};
